import React, { Fragment } from 'react';
import { Route, NavLink, Link, Redirect } from 'react-router-dom';
import { FooterLinks } from './footer-links';

class Footer extends React.Component {
    render () {
        return (
            <div className="mzd-footer main-ui">
                <div className="row expanded align-evenly margin-horizontal-0">
                    {/* Muzado Col */}
                    <div className="column medium-3 margin-left-3">
                        <div className="footer-title">Muzado</div>
                        <ul className="margin-0" style={{listStyleType: 'none'}}>
                            <li><a target="_blank" className="muz-link" href={FooterLinks.ABOUT}>About</a></li>
                            {/* <li><a target="_blank" className="muz-link" href={FooterLinks.FANCENTRAL}>Fan Central</a></li> */}
                            {/* <li><a target="_blank" className="muz-link" href={FooterLinks.HOWITWORKS}>How It Works</a></li> */}
                            <li><Link className="muz-link" to="/coming-soon">Pricing</Link></li>
                            <li><Link className="muz-link" to="/coming-soon">Direct-to-Artist Subscriptions</Link></li>
                            <li><Link className="muz-link" to="/coming-soon">Press</Link></li>
                        </ul>
                    </div>
                    {/* Musicians Col */}
                    <div className="column medium-3">
                        <div className="footer-title">Musicians</div>
                            <ul className="margin-0" style={{listStyleType: 'none'}}>
                                <li><Link className="muz-link" to="/coming-soon">Muzado for Artists</Link></li>
                                <li><Link className="muz-link" to="/coming-soon">Muzado for Fans</Link></li>
                                {/* <li><a target="_blank" className="muz-link" href={FooterLinks.LABELS}>Labels</a></li> */}
                            </ul>
                    </div>
                    {/* Legal Col */}
                    <div className="column medium-3">
                        <div className="footer-title">Legal</div>
                            <ul className="margin-0" style={{listStyleType: 'none'}}>
                                <li><Link className="muz-link" to="/user-terms">Terms and Conditions</Link></li>
                                <li><Link className="muz-link" to="/user-privacy-policy">Privacy Policy</Link></li>
                                <li><a target="_blank" className="muz-link" href={FooterLinks.CONTACTUS}>Contact Us</a></li>
                            </ul>
                    </div>
                    {/*Plugs*/}
                    <div className="column medium-2" style={{display: 'flex', alignItems: 'center'}}>
                        <div className="row" style={{color: '#7f7f7f', fontSize: '2.4rem'}}>
                            <a target="_blank" className="muz-link icon" href={FooterLinks.INSTAGRAM}><i className="margin-right-1 fab fa-instagram"></i></a>
                            <a target="_blank" className="muz-link icon" href={FooterLinks.FACEBOOK}><i className="margin-right-1 fab fa-facebook-f"></i></a>
                            <a target="_blank" className="muz-link icon" href={FooterLinks.YOUTUBE}><i className="margin-right-1 fab fa-youtube"></i></a>
                        </div>
                    </div>
                </div>
                <div className="footer-copyright">
                    <div className="logo-mini alt"></div>
                    <span>© {new Date().getFullYear()} Muzado LLC</span>
                </div>
            </div>
        )
    }
}
export default Footer;